import React from "react";

import { CreditCardIcon } from "../../general/icons/CreditCardIcon";
import { StarIcon } from "../../general/icons/StarIcon";
import { AmexIcon } from "../icons/Amex";
import { DiscoverIcon } from "../icons/Discover";
import { MastercardIcon } from "../icons/Mastercard";
import { VisaIcon } from "../icons/Visa";

export type CardBrand =
  | "AMERICAN_EXPRESS"
  | "CHINA_UNIONPAY"
  | "DISCOVER"
  | "DISCOVER_DINERS"
  | "EBT"
  | "EFTPOS"
  | "FELICA"
  | "INTERAC"
  | "JCB"
  | "MASTERCARD"
  | "OTHER_BRAND"
  | "SQUARE_CAPITAL_CARD"
  | "SQUARE_GIFT_CARD"
  | "UNKNOWN"
  | "VISA";

export const convertCardBrandToIcon = (cardBrand?: CardBrand) => {
  switch (cardBrand) {
    case "VISA":
      return <VisaIcon />;
    case "AMERICAN_EXPRESS":
      return <AmexIcon />;
    case "MASTERCARD":
      return <MastercardIcon />;
    case "DISCOVER":
      return <DiscoverIcon />;
    case "SQUARE_GIFT_CARD":
      return <StarIcon />;
    default:
      return <CreditCardIcon />;
  }
};
